export default "__VITE_ASSET__D5iIpLdJ__"